export default __webpack_public_path__ + "static/media/Start Up Visa.c1865ff6.jpg";